import React, { useEffect, useState } from "react";
import { FaApple, FaGooglePlay, FaTimes } from "react-icons/fa";
import styles from "./Styles/SignupModal.module.css";
import {  appStoreLink,
  playStoreLink,
  getPlatform,
  getDownloadLink,
  Platform, } from "../../utils/appLinks";

const STEPS = [
  {
    title: "Download the app",
    description: "Get Sprinterwave from the App Store or Google Play.",
  },
  {
    title: "Create a free account",
    description: "Sign up as a user, it only takes a minute.",
  },
  {
    title: "Come back and apply",
    description: "Return here to finish your driver application.",
  },
];

const SignupModal: React.FC<{ onCloseHandler: () => void }> = ({
  onCloseHandler,
}) => {
  const [platform, setPlatform] = useState<Platform>("other");

  useEffect(() => {
    setPlatform(getPlatform());
  }, []);

  const primaryLink = getDownloadLink(platform);
  const primaryLabel =
    platform === "ios" ? "Download for iPhone" : "Download for Android";
  const PrimaryIcon = platform === "ios" ? FaApple : FaGooglePlay;

  return (
    <div className={styles.overlay} onClick={onCloseHandler}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button
          className={styles.closeIcon}
          onClick={onCloseHandler}
          aria-label="Close"
        >
          <FaTimes size={16} />
        </button>

        <span className={styles.eyebrow}>Driver application</span>
        <h2>One quick step before you apply</h2>
        <p className={styles.subText}>
          Driver applications happen inside the Sprinterwave app. Download
          it, create a free account, then come back here to continue.
        </p>

        <ol className={styles.steps}>
          {STEPS.map((step, index) => (
            <li key={step.title}>
              <span className={styles.stepNumber}>{index + 1}</span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </li>
          ))}
        </ol>

        <a
          href={primaryLink}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.primaryBtn}
        >
          <PrimaryIcon size={18} />
          {primaryLabel}
        </a>

        <div className={styles.altStores}>
          <span>Or get it directly:</span>
          <div className={styles.storeRow}>
            <a
              href={appStoreLink}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.storeChip}
            >
              <FaApple size={14} /> App Store
            </a>
            <a
              href={playStoreLink}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.storeChip}
            >
              <FaGooglePlay size={14} /> Google Play
            </a>
          </div>
        </div>

        <button onClick={onCloseHandler} className={styles.laterBtn}>
          Maybe later
        </button>
      </div>
    </div>
  );
};

export default SignupModal;